import React, { useRef, useEffect } from "react";
import "./AlertPopup.css";

const AlertPopup = ({ onClose, title, children, txtSubHeading }) => {
  const popupRef = useRef();

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      onClose();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line
  }, [onClose]);

  return (
    <div className="alert-popup">
      <div className="alert-popup-content" ref={popupRef}>
        <div className={`alert-modal-header v-center ${title ? "jcsb" : "jce"}`} style={{ borderBottom: "0px none" }}>
        {title &&<h3 className="fc3">{title}</h3>}
          <span className="fc5 fs14 cp" onClick={onClose}>X</span>
        </div>
       {txtSubHeading && <div className="fs14 fc6 fw4 lh22 ls1">{txtSubHeading}</div>} 
        <div className="alert-modal-body pr">{children}</div>
      </div>
    </div>
  );
};

export default AlertPopup;
